export default function CurrencyNumber(props) {
  return (
    props.number.toLocaleString(props.language || 'en', { minimumFractionDigits: props.fractionDigits || 2 })
  )
}
